import { useRef, useState } from "react";
import { Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import { apiError } from "@/lib/api";
import { cn } from "@/lib/utils";

/** Tablo hücresi: tıkla → düzenle, Enter/odak dışı → ANINDA kaydet, Esc → vazgeç. options verilirse seçim listesi. */
export function EditableCell({ value, display, type = "text", options, onSave, testid, className, align = "left", placeholder = "—", disabled }) {
  const [edit, setEdit] = useState(false);
  const [v, setV] = useState("");
  const [state, setState] = useState("");
  const cancel = useRef(false);
  const start = () => { if (disabled) return; cancel.current = false; setV(value ?? ""); setEdit(true); };
  const commit = async (next = v) => {
    setEdit(false);
    if (cancel.current) return;
    const nv = typeof next === "string" ? next.trim() : next;
    if (String(nv ?? "") === String(value ?? "")) return;
    setState("saving");
    try { await onSave(type === "number" && nv !== "" ? String(nv).replace(",", ".") : nv); setState("ok"); setTimeout(() => setState(""), 1400); }
    catch (e) { setState("err"); toast.error(apiError(e)); setTimeout(() => setState(""), 2200); }
  };
  const right = align === "right";
  if (edit && options) {
    return (
      <select autoFocus value={v} onChange={(e) => { setV(e.target.value); commit(e.target.value); }} onBlur={() => setEdit(false)}
        className="w-full py-1 px-1.5 text-sm border-2 border-[#0F2745] rounded bg-white shadow-md focus:outline-none" data-testid={`${testid}-input`}>
        {options.map((o) => <option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>)}
      </select>
    );
  }
  if (edit) {
    return (
      <input autoFocus value={v} inputMode={type === "number" ? "decimal" : undefined} onChange={(e) => setV(e.target.value)} onBlur={() => commit()}
        onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); if (e.key === "Escape") { cancel.current = true; setEdit(false); } }}
        className={cn("w-full min-w-[60px] py-1 px-2 text-sm border-2 border-[#0F2745] rounded bg-white shadow-md focus:outline-none", right && "text-right tnum")} data-testid={`${testid}-input`} />
    );
  }
  return (
    <button type="button" onClick={start} disabled={disabled} title={disabled ? undefined : "Düzenlemek için tıklayın"}
      className={cn("w-full min-h-[28px] rounded px-1.5 py-1 inline-flex items-center gap-1 transition-colors duration-300 text-left",
        right && "justify-end text-right", !disabled && "hover:bg-slate-100 cursor-text", state === "ok" && "bg-emerald-100 text-emerald-800",
        state === "err" && "bg-red-100 text-red-700", className)} data-testid={testid}>
      {state === "saving" && <Loader2 className="h-3 w-3 animate-spin text-slate-400 shrink-0" />}
      {state === "ok" && <Check className="h-3 w-3 text-emerald-600 shrink-0" />}
      <span className={cn("min-w-0", right ? "tnum" : "break-words")}>{display ?? (value === "" || value == null ? <span className="text-slate-300">{placeholder}</span> : value)}</span>
    </button>
  );
}
